<template>
  <div class="container__method-form">
    <label class="h5 font-weight-bold mb-4 title__method-form"> Method components </label>
    <div class="mb-4">
      <label for="input__method-overview" class="mb-u4 label__method-overview">
        Method overview
      </label>
      <base-text-editor
        id="input__method-overview"
        v-model="form.method_overview"
        :disabled="disabled"
        class="mb-4 input__method-overview"
        name="input__method-overview"
        placeholder="Insert your method overview"
      />
    </div>

    <div>
      <label for="input__how-achive" class="mb-u4 label__how-achieve">
        How can you achieve ?
      </label>
      <base-text-editor
        id="input__how-achive"
        v-model="form.how_achieve"
        class="input__how-achieve"
        name="input__how-achive"
        placeholder="Insert how can you achieve ?"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import BaseTextEditor from '@/components/base-components/BaseTextEditor';

export default {
  components: {
    BaseTextEditor
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    modelValue: {
      type: Object,
      default: () => ({
        method_overview: null,
        how_achieve: null
      })
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        method_overview: this.modelValue.method_overview,
        how_achieve: this.modelValue.how_achieve
      }
    };
  },

  watch: {
    form: {
      deep: true,
      handler(value) {
        this.$emit('change', value);
      }
    },
    modelValue: {
      deep: true,
      immediate: true,
      handler(modelValue) {
        this.updateForm(modelValue);
      }
    }
  },
  methods: {
    updateForm(modelValue) {
      this.$set(this.form, 'method_overview', modelValue.method_overview);
      this.$set(this.form, 'how_achieve', modelValue.how_achieve);
    }
  }
};
</script>
